<template>
  <div>
    h5-to-app-test-2
  </div>
</template>

<script>
export default {
  name: 'h5ToAppTest'
}
</script>

<style scoped lang="less">

</style>